// AUTOGENERATED FROM packages/deploy/addresses.testnet.json — DO NOT EDIT BY HAND. Run `pnpm generate` (from packages/chains) to refresh.
import type { Address } from 'viem';

// Source: packages/deploy/addresses.testnet.json. Refresh this when Bittensor testnet deploy addresses change.
//
// Entries mirror the live Bittensor testnet deployment in packages/deploy/addresses.testnet.json.

export const testnetAddresses = {
  accessControlManager: '0xdc685937648a0117A1E4Ed1CD3B1fd1fa09Dd55b',
  acmCommandsAggregator: '0xa4663F07F846f8fd7cd7b4BA2F7F1D6A9A6D4271',
  comptrollerLens: '0x6F4255785a938939a72E364680BdC256f2Ad57fd',
  diamond: '0x0E8f68743dc26F8D1192a02CAB3058ddf31c5C26',
  flashLoanFacet: '0x7d87859953e95DB78657E20Ea77eD04844c3baA0',
  irmAlpha: '0xF9c5a748D501557903692977bd2d8dC1F058F9D9',
  irmWTAO: '0xBD3B8Ef540f8F859A8b4efFbfb4af55D7230263d',
  marketFacet: '0x1D7bcBf54807835d0614A5C96e23F09957045250',
  mockAlpha30: '0x1D5E4617ad59c1A4428526F6994410e513587a96',
  mockAlpha64: '0xd36F494aC4D7dd5674c1a21B65FD4f5Fee14A8b4',
  policyFacet: '0x6ced71F05585edFa03f7159FaF10c05e49B9E877',
  resilientOracle: '0x41863a7EEd574BDFa2D798b16712d65548E9d5d2',
  rewardFacet: '0x4B938504E1256Dc9C1F5637730a56C18fe9abfCc',
  setterFacet: '0x250e69EFA0A6A2C7E48CCa5c7A7E3B66a4a84990',
  unitroller: '0x999C6a7ee03aE0C0a18503C2ECA0C8d5a9f69f31',
  vAlpha30: '0x037b37B4523C5f5D5291460d01a53778f9d7D6c3',
  vAlpha64: '0x89abcEfBb63bd153f0B60D50Ba04f7f0b8E4294E',
  vWTAO: '0x306065C8277ef65741B1CBeB095d755aF4B4b7cf',
  wtao: '0x757bbFffe6f08FEbBE19638833FfADaa7B369C25',
  wsTAO: '0xcff46eb93307ca7E24A7cE2A1Eb0F485A27D461a',
  wsTAOPriceFeed: '0x20D2C0A595EE2bc2fBA5D50b8EbD1427dEE095f4',
  vWsTAO: '0x782E5a6Dc16901ec13D4D1e450A8270F4e6E75cf',
  // wAlpha testnet markets
  bittensorNativeAlphaFeed: '0xBEA6a2F3D7AC11490f972aaE9F518e3AE783D491',
  wAlphaStashFaucet: '0x35c23b26B3A6bF06a5ECdD7420e800dB7c7866Fe',
  wAlpha288: '0x0969f7bd66273fc42CC03205c8CaaE575989e7E2',
  wAlpha333: '0x0f5CC30B11D958728a4304Db730E7C7De0ec5DC7',
  wAlpha418: '0x97a4aacF22a94cCf2bCED5805cD9b29761aA3683',
  wAlphaPriceFeed288: '0x208100f0A67b6a708fe1677ec995F93C99416Cf7',
  wAlphaPriceFeed333: '0x21eF331cfec32FcD55d55E88399DbB23153DB7E9',
  wAlphaPriceFeed418: '0x404D0a1Ebe3a2d662e38e82CDbdbeF617FFFEC82',
  vWAlpha288: '0x35274c07b1fa24687E4Ae958274A00a0D863D98B',
  vWAlpha333: '0xB62981B2BCF8BF075fb1179D041DACbc2dfeCC0B',
  vWAlpha418: '0x94f8f2D41bdBA439848B14609C41faD68e8cb1c7',
  wAlpha288V2: '0x7e81f63a4CeA09040F111314a0E5Ff61249a51D7',
  wAlpha333V2: '0xC2f945887c3Ff61b3E5Aa7aDE291228a4B4c5d37',
  wAlpha418V2: '0x407F2BEb996d173e34C5EC495cC80a5271Bdb77d',
  wAlphaPriceFeed288V2: '0x831dA013D0fb08004826A318b913AE15D1f97631',
  wAlphaPriceFeed333V2: '0x4965bfF7d90faD61Cf6f79a6e6FA9EA09Dd29A1d',
  wAlphaPriceFeed418V2: '0x43494C5B3fb64B1d4F40837439c1C9E2A5c7927E',
  vWAlpha288V2: '0x951cd503dA38343654E377Cf7683B13dA2a378f6',
  vWAlpha333V2: '0x7c81fe0603A144763bE70429Bd57f8e2C46De570',
  vWAlpha418V2: '0x695b0D0A6AA46f91ebb4dC04585cCC51b7e8a5fc',
  acmGatedProxyAdmin: '0x4673Bf0fe11E31B47b4D4ef562CCA0706e4873b1',
  wsTAOUpgradeable: '0x182B33D82A7ed859B5f8fB48f878249fD5F614bb',
  wsTAOUpgradeableImpl: '0xAFB129426C7469D6D65DCe1C1886e7c3A2469aA6',
  wsTAOPriceFeedV3: '0x04e4686b22a5dE65A02aFC56A0369996347b8E38',
  vWsTAOV3: '0xDE433c4A00cA6232ACa16209302a4bEE897C7b71',
  wAlpha288V3: '0xcC87419E59d3F83cCf9A416d158BF38387f5919a',
  wAlpha288V3Impl: '0xad12Bb873A707980fe50150d8E4ddEd4Fa4DBe9c',
  wAlphaPriceFeed288V3: '0x9508f4D279Fd971C6912C0314d9948A9D79fdB7A',
  vWAlpha288V3: '0xE2B100226E085b14E8a8ba3F224d7941fc1F850A',
  wAlpha333V3: '0xA7620e8344016c6795aAcd5877D5a5916068e700',
  wAlpha333V3Impl: '0x0ce5553E4D9B1E9D9D2c9E4c558fb502c0849F89',
  wAlphaPriceFeed333V3: '0x644B1F9a891bE66923B314D41764fb875a7e92b1',
  vWAlpha333V3: '0x94FBD6a3C06FE8e99dB611c598009544543c5322',
  wAlpha418V3: '0x8cAA27cAb1Fb0e95Ac1A47c0649b1683AB761d0b',
  wAlpha418V3Impl: '0xa2655A9f929cDCC6c89b570d0087230cF37E37de',
  wAlphaPriceFeed418V3: '0xeD02747E3a7635DAc1ea9cE08D18B43a7A0b8Ad3',
  vWAlpha418V3: '0xb787d78C288F1842a24562B8F5056f07bdf35932',
  positionRouter: '0x44E19375a81067419B7a2C6130249E7dEE167499',
} as const satisfies Record<string, Address>;
